/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use commas, spaces, semicolons or new lines — any mix works. Non-numeric text is ignored.`)
};

const es_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa comas, espacios, punto y coma o saltos de línea — cualquier combinación funciona. El texto no numérico se ignora.`)
};

const de_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwende Kommas, Leerzeichen, Semikolons oder Zeilenumbrüche — jede Mischung funktioniert. Nicht-numerischer Text wird ignoriert.`)
};

const nl_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik komma's, spaties, puntkomma's of nieuwe regels — elke combinatie werkt. Niet-numerieke tekst wordt genegeerd.`)
};

const fr_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez des virgules, espaces, points-virgules ou retours à la ligne — tout mélange fonctionne. Le texte non numérique est ignoré.`)
};

const it_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa virgole, spazi, punti e virgola o a capo — funziona qualsiasi combinazione. Il testo non numerico viene ignorato.`)
};

const pt_br2_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use vírgulas, espaços, ponto e vírgula ou quebras de linha — qualquer combinação funciona. Texto não numérico é ignorado.`)
};

const pt_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use vírgulas, espaços, ponto e vírgula ou novas linhas — qualquer combinação funciona. O texto não numérico é ignorado.`)
};

const ja_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマ、スペース、セミコロン、改行のいずれか、または組み合わせて使用できます。数値以外のテキストは無視されます。`)
};

const zh_st_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用逗号、空格、分号或换行均可，也可以混用。非数字文本会被忽略。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_faq_a4", locale)
	if (locale === "en") return en_st_faq_a4(inputs)
	if (locale === "es") return es_st_faq_a4(inputs)
	if (locale === "de") return de_st_faq_a4(inputs)
	if (locale === "nl") return nl_st_faq_a4(inputs)
	if (locale === "fr") return fr_st_faq_a4(inputs)
	if (locale === "it") return it_st_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_st_faq_a4(inputs)
	if (locale === "pt") return pt_st_faq_a4(inputs)
	if (locale === "ja") return ja_st_faq_a4(inputs)
	return zh_st_faq_a4(inputs)
};